// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__JTcIO","content":"styles_content__2ZsHj","checkbox":"styles_checkbox__3oAW6","checkboxLabel":"styles_checkboxLabel__1UMXK"};